<div
  class="checkbox-form--wrapper nx-formfield__wrapper nx-formfield"
  [formGroup]="formGroup"
  [ngClass]="field.class || []"
>
  <div
    class="checkbox-form--content"
    [ngClass]="['checkbox-form--align_' + (field.align || 'left')]"
  >
    <nx-checkbox-group [formControlName]="field.name" [name]="field.name">
      <nx-label [size]="field.labelSize ?? 'large'">
        {{ field.label | translate }}
        <span *ngIf="field.required">*</span>
      </nx-label>
      <nx-checkbox
        *ngFor="let item of field.list"
        class="nx-margin-bottom-s nx-margin-right-s"
        [value]="item.value"
        [labelSize]="field.labelSize ?? 'large'"
      >
        {{ item.text | translate }}
      </nx-checkbox>
      <app-popover-form
        *ngIf="field.popover"
        nxFormfieldSuffix
        [popover]="field.popover"
        (popoverShow)="onPopoverShow($event)"
      ></app-popover-form>
    </nx-checkbox-group>
  </div>

  <ng-container *ngIf="formGroup.controls[field.name].touched">
    <nx-error
      nxFormfieldError
      *ngFor="let item of formGroup.controls[field.name]?.errors || {} | arrayKeys"
    >
      {{
        (field.customErrorLabel && field.customErrorLabel[item]
          ? field.customErrorLabel[item]
          : 'azForm.errors.' + item
        ) | translate
      }}
    </nx-error>
  </ng-container>
</div>
